"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    plainButtonVariants: ()=>plainButtonVariants,
    PlainButtonTypes: ()=>PlainButtonTypes
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const plainButtonVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        buttonSlot: 'focus-visible:ring-actionSecondary-12 group inline-flex cursor-pointer flex-row items-center justify-center gap-1 rounded-md ring-offset-2 transition focus-visible:outline-none focus-visible:ring-2',
        textSlot: 'underline transition',
        iconSlot: 'no-underline transition hover:no-underline'
    },
    variants: {
        type: {
            primary: '',
            secondary: '',
            critical: ''
        },
        textStyle: {
            body1: {
                buttonSlot: 'text-body1',
                iconSlot: 'text-icon-24 h-[24px] w-[24px]'
            },
            body2: {
                buttonSlot: 'text-body2',
                iconSlot: 'text-icon-20 h-[20px] w-[20px]'
            },
            body3: {
                buttonSlot: 'text-body3',
                iconSlot: 'text-icon-16 h-[16px] w-[16px]'
            },
            heading4: {
                buttonSlot: 'text-heading4',
                iconSlot: 'text-icon-24 h-[24px] w-[24px]'
            },
            heading5: {
                buttonSlot: 'text-heading5',
                iconSlot: 'text-icon-20 h-[20px] w-[20px]'
            },
            heading6: {
                buttonSlot: 'text-heading6',
                iconSlot: 'text-icon-16 h-[16px] w-[16px]'
            }
        },
        emphasis: {
            regular: '',
            medium: '',
            bold: ''
        },
        disabled: {
            true: {
                buttonSlot: 'cursor-not-allowed'
            }
        }
    },
    compoundVariants: [
        {
            emphasis: 'regular',
            type: 'primary',
            class: {
                buttonSlot: 'text-actionPrimary-8 group-hover/attribute:text-actionPrimary-9 hover:text-actionPrimary-9'
            }
        },
        {
            emphasis: 'regular',
            type: 'secondary',
            class: {
                buttonSlot: 'text-actionSecondary-13 group-hover/attribute:text-actionSecondary-4 hover:text-actionSecondary-4'
            }
        },
        {
            emphasis: 'regular',
            type: 'critical',
            class: {
                buttonSlot: 'text-actionCritical-8 group-hover/attribute:text-actionCritical-9 hover:text-actionCritical-9'
            }
        },
        {
            emphasis: 'medium',
            type: 'primary',
            class: {
                buttonSlot: 'text-actionPrimary-8 group-hover/attribute:text-actionPrimary-9 hover:text-actionPrimary-9'
            }
        },
        {
            emphasis: 'medium',
            type: 'secondary',
            class: {
                buttonSlot: 'text-actionSecondary-13 group-hover/attribute:text-actionSecondary-4 hover:text-actionSecondary-4'
            }
        },
        {
            emphasis: 'medium',
            type: 'critical',
            class: {
                buttonSlot: 'text-actionCritical-8 group-hover/attribute:text-actionCritical-9 hover:text-actionCritical-9'
            }
        },
        {
            emphasis: 'bold',
            type: 'primary',
            class: {
                buttonSlot: 'text-actionPrimary-1 group-hover/attribute:text-actionPrimary-1 hover:text-actionPrimary-1'
            }
        },
        {
            emphasis: 'bold',
            type: 'secondary',
            class: {
                buttonSlot: 'text-actionSecondary-1 group-hover/attribute:text-actionSecondary-1 hover:text-actionSecondary-1'
            }
        },
        {
            emphasis: 'bold',
            type: 'critical',
            class: {
                buttonSlot: 'text-actionCritical-1 group-hover/attribute:text-actionCritical-1 hover:text-actionCritical-1'
            }
        },
        {
            disabled: true,
            class: {
                buttonSlot: 'text-actionPrimary-6 group-hover/attribute:text-actionPrimary-6 hover:text-actionPrimary-6',
                textSlot: 'group-hover/attribute:no-underline'
            }
        },
        {
            emphasis: 'bold',
            disabled: true,
            class: {
                buttonSlot: 'text-actionPrimary-1/40 group-hover/attribute:text-actionPrimary-1/40 hover:text-actionPrimary-1/40'
            }
        }
    ],
    defaultVariants: {
        type: 'secondary',
        emphasis: 'regular',
        textStyle: 'body2'
    }
});
const PlainButtonTypes = Object.keys(plainButtonVariants.variants.type);
exports.PlainButtonTypes = __webpack_exports__.PlainButtonTypes;
exports.plainButtonVariants = __webpack_exports__.plainButtonVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "PlainButtonTypes",
    "plainButtonVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
